import React, { useEffect } from "react";
import SecPlateDetails from "../components/PlateDetails/SecPlateDetails";
import UserSidepanel from "../shared/userSidepanel";
import { useParams } from "react-router";
import { checkDriverVehicle } from "../actions/site";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
const PlateDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    if (localStorage.getItem("access_token")) {
      dispatch(async () => {
        try {
          const data = await checkDriverVehicle();
          if (data.status == 200) {
            if (data.step == 1) {
              return navigate("/add-driver");
            } else if (data.step == 2) {
              return navigate("/add-plate");
            }
          } else {
            return navigate("/add-driver");
          }
        } catch (err) {
          console.log(err.message);
        }
      });
    }
  }, [dispatch, window.location.pathname]);
  return (
    <section className="sec-panel login-part-pages">
      <div className="container">
        <div className="row user-panel-menus">
          <div className="left-sidebar">
            <UserSidepanel />
          </div>
          <div className="right-sidebar">
            <SecPlateDetails id={id} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default PlateDetails;
